export default "__VITE_ASSET__DuI5QTjV__"